// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vH1g4","tabsBox":"styles_tabsBox__4NxA-","createButton":"styles_createButton__2bTrm"};